import { Permission } from 'shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import CreateCustomFieldModalBody from './components/CreateCustomFieldModalBody'
import { useGlobalState } from 'context/GlobalStateContext'
import { useCustomFieldPageContext } from '../../CustomFieldPageContext'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useCreateCustomFieldMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateCustomFieldModalBodyValues } from './components/CreateCustomFieldModalBody/types'
import { ProjectCustomField } from 'components/CustomFields/ProjectCustomFieldsContext/types'
import { errorHandler } from 'hooks/errorHandler'

export function useCreate() {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { fetching, refetch } = useProjectCustomFieldsContext()
  const { toInputs } = useCustomFieldPageContext()
  const [create] = useCreateCustomFieldMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createCustomField: {
        customField: { name },
      },
    }) => simpleCreateNotification(name),
  })
  const options: CreateHeaderActionOptions<ProjectCustomField> = {
    entity: 'Custom Field',
    permission: Permission.CreateCustomField,
    loading: fetching,
    modal: {
      body: <CreateCustomFieldModalBody />,
      onOk: async ({
        name,
        description,
        dataTypeId,
        styleId,
        entityIds,
        reportIds,
        customFieldToClassTypes,
        customListItems,
        timestamp,
      }: CreateCustomFieldModalBodyValues) => {
        if (!projectId) {
          return errorHandler('Project id must be defined')
        }

        await create({
          variables: {
            createCustomFieldInput: {
              projectId,
              name,
              description,
              dataTypeId,
              metadata: { styleId, entityIds, reportIds, timestamp },
              customListItems,
              customFieldToClassTypeInputs: toInputs(customFieldToClassTypes),
            },
          },
        })
        refetch()
      },
    },
  }
  return options
}
